
    import '/home/runner/work/GPT-Vis/GPT-Vis/src/Text/index.en.md?watch=parent';
    export const demoIndex = {
  ids: ["src-text-demo-common","src-text-demo-markdown","src-text-demo-custom-markdown"],
  getter: () => import(/* webpackChunkName: "meta__Text__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Text/index.en.md?type=demo')
};